import axios from 'axios';

/**
 * Componente para envío de correo de liga pagada.
 * @param {cliente,pedido,monto,correo} enviarCorreoPago 
 * @returns boolean
 */
export const enviarCorreoPago = async (cliente, pedido, monto, correo, transactionId, fecha) => {
    let logoSucursal = 'autex_blanco.png';

    var bodyCorreo = "<div style='width:800px;margin:auto;border:1px solid gray;font-family:Arial,Helvetica,sans-serif;'>" +
        "<div style='width:100%;height:180px;display:flex;align-items:center;background-color:#003396;text-align:center;'>" +
        "<img src='https://resources.apymsa.com.mx/imagenes/" + logoSucursal + "' style='width:350px;margin: 0 auto;'/>" +
        "</div>" +
        "<div style='padding:30px;font-size:18px;'>" +
        "<div>" +
        "<p><b>Estimado {CLIENTE}</b></p>" +
        "<p>Gracias por tu pago en línea de tu pedido solicitado por medio de nuestro Contact Center.</p>" +
        "<br>" +
        "<p style='text-align:center;'>Transaccion Id: <b>{transactionId}</b> Fecha: <b>{fecha}</b></p>" +
        "<p style='text-align:center;'>Pedido <b>{PEDIDO}</b> por <b>$</b><b>{MONTO}</b> pesos</p>" +
        "</div>" +
        "<br>" +
        "<div style='font-size:17px;'>" +
        "<p><i>Si no realizaste este pedido te sugerimos no compartir tu cuenta, este correo solo es informativo, no es necesario respoder a el.</i></p>" +
        "</div>" +
        "</div>" +
        "</div>";



    bodyCorreo = bodyCorreo.replace('{CLIENTE}', cliente);
    bodyCorreo = bodyCorreo.replace('{PEDIDO}', pedido);
    bodyCorreo = bodyCorreo.replace('{transactionId}', transactionId);
    bodyCorreo = bodyCorreo.replace('{fecha}', fecha);
    bodyCorreo = bodyCorreo.replace('{MONTO}', monto);

    var data = {
        correo: correo,
        asunto: 'Confirmación de pago',
        mensaje: bodyCorreo 
    }

    const config = {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem("tokenBearer")}` ,
            'X-OrigenId': '9',
            'X-ExodusDev': '0'
        }
    }

    return await axios.post(process.env.REACT_APP_ENVIAR_CORREO, JSON.stringify(data), config)
        .catch(function (error) {
            if (error.response) {
                return false;
            }
        });
}